module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_7042.81910e06.png";